import React from "react";
import { Container } from '@/components/ui/container';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

const testimonials = [
  {
    id: 1,
    name: "Varun Kambra",
    designation: "Working at Tech Corp",
    message:
      "Looking back on my journey to securing my first job after masters, I am filled with immense gratitude for your unwavering support and guidance. Your mentorship played a crucial role in shaping my career trajectory, and I am forever thankful for your invaluable assistance.",
    image: "/Varun.jpg"
  },
  {
    id: 2,
    name: "Harday Mittal",
    designation: "Working at Miko",
    message:
      "My journey to success in landing my first job was greatly shaped by the comprehensive course provided by NewZenAlphaTech. Their structured approach equipped me with the necessary skills and confidence to step into the professional world with assurance!",
    image: "/Ellipse 1.jpg"
  },
];

function Testimonials() {
  return (
    <section id="test-section" className="py-12 md:py-16 lg:py-20 bg-background">
      <Container>
        <Stack spacing="xl" align="center">
          <Heading level="h2" className="text-3xl md:text-4xl font-bold text-center">
            What Our Clients Say About Us
          </Heading>
          
          {/* Testimonials Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-4xl">
            {testimonials.map((testimonial) => (
              <Card
                key={testimonial.id}
                className={cn(
                  "bg-card border-border/50 shadow-md hover:shadow-lg",
                  "transition-all duration-300"
                )}
              >
                <CardContent className="p-6 text-center">
                  <Avatar className="h-20 w-20 mx-auto mb-4">
                    <AvatarImage
                      src={testimonial.image}
                      alt={testimonial.name}
                    />
                    <AvatarFallback className="bg-muted text-foreground">
                      {testimonial.name.charAt(0)}
                    </AvatarFallback>
                  </Avatar>
                  <Text className="italic text-muted-foreground mb-4">
                    "{testimonial.message}"
                  </Text>
                  <Heading level="h3" className="text-lg font-semibold mb-1">
                    {testimonial.name}
                  </Heading>
                  <Text variant="muted" className="text-sm">
                    {testimonial.designation}
                  </Text>
                </CardContent>
              </Card>
            ))}
          </div>
        </Stack>
      </Container>
    </section>
  );
}

export default Testimonials;
